import getColor from "./theme/getColor.js";
import getFontSize from "./theme/getFontSize.jsx";
import getLength from "./theme/getLength.jsx";
import getLengthPx from "./theme/getLengthPx.jsx";
import getTextColor from "./theme/getTextColor.js";

export default function ({ colors, ...input }) {
  const theme = {
    ...input,
    colors,
  };

  theme.styleUtils = {
    visuallyHidden: {
      position: "absolute",
      width: "1px",
      height: "1px",
      padding: "0",
      clip: "rect(0,0,0,0)",
      pointerEvents: "none",
      margin: "-1px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      borderWidth: "0",
      "@media not screen": {
        display: "none",
      },
    },
    buttonReset: {
      /* RESET */
      display: "inline-block",
      border: "none",
      margin: "0",
      padding: "0",
      width: "auto",
      overflow: "visible",
      textAlign: "inherit",

      background: "transparent",

      /* inherit font & color from ancestor */
      color: "inherit",
      font: "inherit",
      textDecoration: "inherit",

      /* Normalize line-height. Cannot be changed from normal in Firefox 4+. */
      lineHeight: "normal",

      /* Corrects font smoothing for webkit */
      WebkitFontSmoothing: "inherit",
      MozOsxFontSmoothing: "inherit",

      /* Corrects inability to style clickable input types in iOS */
      WebkitAppearance: "none",
    },
    negateMarginStart: {
      "&:before": {
        content: '""',
        display: "block",
        marginBlockStart: "-999px",
        marginBlockEnd: "999px",
      },
    },
    negateMarginEnd: {
      "&:after": {
        content: '""',
        display: "block",
        marginBlockStart: "999px",
        marginBlockEnd: "-999px",
      },
    },
    colorTheme: (color) => ({
      "--background-color": theme.getColor(color),
      "--text-color": theme.getColor([color, "text"]),
      "--link-color": theme.getColor([color, "link"]),
      "--icon-color": theme.getColor([color, "icon"]),
      backgroundColor: "var(--background-color, transparent)",
      color: "var(--text-color, inherit)",
    }),
  };

  theme.getColor = getColor(theme);
  theme.getTextColor = getTextColor(theme);
  theme.getLength = getLength(theme);
  theme.getLengthPx = getLengthPx(theme);
  theme.getFontSize = getFontSize(theme);

  return theme;
}
